import { render, staticRenderFns } from "./certificate-file-modal.vue?vue&type=template&id=160cbcaa&"
import script from "./certificate-file-modal.vue?vue&type=script&lang=js&"
export * from "./certificate-file-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports